import { render, staticRenderFns } from "./ProductStat.vue?vue&type=template&id=a548f446&scoped=true&"
import script from "./ProductStat.vue?vue&type=script&lang=js&"
export * from "./ProductStat.vue?vue&type=script&lang=js&"
import style0 from "./ProductStat.vue?vue&type=style&index=0&id=a548f446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a548f446",
  null
  
)

export default component.exports